export default __webpack_public_path__ + "static/media/priest.d151dafa.png";